import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {MODAL_VIEW_STATE, VIEW_STATE} from "../utils/enums";
import utils from "../utils";
import toast from "../utils/toast";

const initialUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
const slice = createSlice({
    name: 'user', initialState: {
        viewState: VIEW_STATE.LOADING,
        modalViewState: MODAL_VIEW_STATE.NOT_LOADING,
        modalViewState2: MODAL_VIEW_STATE.NOT_LOADING,
        user: initialUser,
        form:null
    }, reducers: {
        setViewState: (state, action) => {
            state.viewState = action.payload
        },
        setModalViewState: (state, action) => {
            state.modalViewState = action.payload
        },
        setModalViewState2: (state, action) => {
            state.modalViewState2 = action.payload
        },
        setForm: (state, action) => {
            state.form = action.payload
            state.viewState = VIEW_STATE.LOADED
        },
        onLogin: (state, action) => {
            state.user = action.payload;
            localStorage.setItem('user', JSON.stringify(action.payload))
            state.modalViewState = MODAL_VIEW_STATE.NOT_LOADING
            state.modalViewState2 = MODAL_VIEW_STATE.NOT_LOADING
        },
        setUser: (state, action) => {
            const user={...state.user,...action.payload}
            localStorage.setItem('user', JSON.stringify(user))
            state.user = user;
            state.modalViewState = MODAL_VIEW_STATE.NOT_LOADING
            state.modalViewState2 = MODAL_VIEW_STATE.NOT_LOADING
            state.viewState = VIEW_STATE.LOADED
        },
        unsetUser: (state, action) => {
            localStorage.removeItem('user')
            state.user = null
        },
        onError: (state, action) => {
            state.modalViewState = MODAL_VIEW_STATE.NOT_LOADING
            state.modalViewState2 = MODAL_VIEW_STATE.NOT_LOADING
            toast.error(action.payload);
        },
    },
});

export default slice.reducer

const {setModalViewState, onLogin, setUser, unsetUser, onError,setModalViewState2,setViewState,setForm} = slice.actions

export const login = (phoneNumber, onSuccess,t) => async dispatch => {
    try {
        dispatch(setModalViewState(MODAL_VIEW_STATE.LOADING))
        await api.user.login(phoneNumber)
        dispatch(setModalViewState(MODAL_VIEW_STATE.NOT_LOADING))
        onSuccess()

    } catch (e) {
        const message = e.response?.data?.message ?? t("errorInConnection")
        dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
    }
}
export const verify = (phoneNumber, code,t) => async dispatch => {
    try {
        dispatch(setModalViewState2(MODAL_VIEW_STATE.LOADING))
        const {data} = await api.user.verify(phoneNumber, code)
        dispatch(onLogin(data.data));
        dispatch(setModalViewState2(MODAL_VIEW_STATE.NOT_LOADING))
    } catch (e) {
        const message = e.response?.data?.message ?? t("errorInConnection")
        dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
    }
}

export const getProfile = (onSuccess,t) => async dispatch => {
    try {
        if(!!onSuccess)dispatch(setModalViewState(MODAL_VIEW_STATE.LOADING))
        else dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.user.get()
        onSuccess?.(data?.data)
        dispatch(setUser(data?.data))
    } catch (e) {
        const message = e.response?.data?.message ?? t("errorInConnection")
        if(!!onSuccess)dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
        else dispatch(setViewState(VIEW_STATE.ERROR))
    }
}

export const updateProfile = (user, setSubmitting,t) => async dispatch => {
    try {
        dispatch(setModalViewState(MODAL_VIEW_STATE.LOADING))
        const {data} = await api.user.update(user)
        dispatch(setUser(data?.data))
        toast.success(t("changesSaved"))
        setSubmitting(false)
    } catch (e) {
        const message = e.response?.data?.message ?? t("errorInConnection")
        dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
        setSubmitting(false)
    }
}

export const getLastForm = () => async dispatch => {
    try {
        dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.user.getLastForm()
        dispatch(setForm(data?.data))
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}

export const saveForm = (form, onSuccess,setSubmitting,t) => async dispatch => {
    try {
        dispatch(setModalViewState(MODAL_VIEW_STATE.LOADING))
        await api.user.saveForm(form)
        onSuccess()
        setSubmitting(false)
        dispatch(setForm({}))

    } catch (e) {
        const message = e.response?.data?.message ?? t("errorInConnection")
        dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
        setSubmitting(false)
    }
}

export const logout = () => dispatch => dispatch(unsetUser())